import React, { forwardRef, useMemo } from 'react'
import { FieldTypes } from 'utils/formUtils';
import AcunetixMappingForm from './AcunetixMappingForm';
import GenericPullCredentialsForm from '../GenericPullCredentialsForm';
import { urlRegexValidator } from 'utils/formUtils';

function AcunetixCredentialsForm(props, ref) {
    const fields = useMemo(() => [
        {
            name: "apiEndpoint",
            label: "Acunetix Endpoint",
            required: true,
            rules: [urlRegexValidator],
        },
        {
            name: "token",
            label: "Token",
            type: FieldTypes.PASSWORD,
            required: true
        }
    ],[])

    return (
        <GenericPullCredentialsForm
            {...props}
            ref={ref}
            fields={fields}
            MappingForm={AcunetixMappingForm}
            initialValue={{ apiEndpoint: 'https://online.acunetix360.com/api/1.0' }}
        />
    )
}

export default forwardRef(AcunetixCredentialsForm);